import { useEffect, useState, ChangeEvent } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { TextField, Stack, Container, Grid, Button } from "@mui/material";

import Logo from "../assets/img/logo.svg";

import { NavigationComponent } from "./navigation";

import { useAppDispatch } from "../redux/hooks";
import { auth, message, backdrop } from "../redux/app.slice";

import { verifyService, authService } from "../modules/service";

export const AuthComponent = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const { id, secret, country, phone } = useParams();

  const [Student, SetStudent] = useState<{ code: string }>({
    code: "",
  });

  const [Error, SetError] = useState<{ code: boolean }>({
    code: false,
  });

  const HandleChange = (event: ChangeEvent<HTMLInputElement>) => {
    SetStudent({ ...Student, [event.target.name]: event.target.value });
  };

  useEffect(() => {
    if (id && secret && country && phone) {
      dispatch(backdrop(true));
      verifyService(id, secret, country, phone)
        .then((res) => {})
        .catch((err) => {
          dispatch(
            message({
              message:
                "The link you are trying to use is invalid or has expired.",
              severity: "error",
              open: true,
            })
          );
          navigate("/");
        })
        .finally(() => dispatch(backdrop(false)));
    } else
      dispatch(
        message({
          message: "The link you are trying to use is invalid or has expired.",
          severity: "error",
          open: true,
        })
      );
  }, [id, secret, country, phone, navigate, dispatch]);

  const HandleValidate = () => {
    let error: { code: boolean } = {
      code: true,
    };

    if (Student.code === "") error.code = true;
    else error.code = false;

    SetError(error);

    return Object.values(error).every((value) => value === false);
  };

  const HandleSubmit = () => {
    if (HandleValidate() && id && secret && country && phone) {
      dispatch(backdrop(true));
      const student_form_data = new FormData();
      student_form_data.append("code", Student.code);
      student_form_data.append("id", id);
      student_form_data.append("secret", secret);
      student_form_data.append("country", country);
      student_form_data.append("phone", phone);
      authService(student_form_data)
        .then((response) => {
          dispatch(
            auth({
              student: response.data.student,
              token: response.data.token,
            })
          );
          navigate("/dashboard");
        })
        .catch((error) => {
          dispatch(
            message({
              message: "The entered code is incorrect. Please try again.",
              severity: "error",
              open: true,
            })
          );
          navigate("/");
        })
        .finally(() => dispatch(backdrop(false)));
    } else
      dispatch(
        message({
          message: "The link you are trying to use is invalid or has expired.",
          severity: "error",
          open: true,
        })
      );
  };

  return (
    <>
      <NavigationComponent />
      <Container maxWidth="sm" style={{ margin: "2em auto" }}>
        <Stack spacing={2}>
          <Grid
            container
            spacing={0}
            direction="column"
            alignItems="center"
            justifyContent="center"
            style={{ marginBottom: "1em" }}
          >
            <img
              src={Logo}
              width={100}
              alt="London School of Commerce Group of Colleges Logo"
            />
          </Grid>

          <TextField
            name="code"
            type={"number"}
            error={Error.code}
            label="One time code"
            value={Student.code}
            onChange={HandleChange}
            helperText="Please enter the one time code sent to your phone"
            fullWidth
          />
          <Button
            variant="contained"
            disableElevation
            size="large"
            onClick={HandleSubmit}
          >
            Login
          </Button>
        </Stack>
      </Container>
    </>
  );
};
